import React, { Component } from 'react'
import Cookie from 'js-cookie'
import { compose } from 'redux'
import { connect } from 'react-redux'
import { selectCookieConsentParams } from '../../../store/site'
import withStyles from 'constructicon/with-styles'
import styles from './styles'

import Button from '../../ui/Button'

class CookieConsent extends Component {
  constructor () {
    super()
    this.shouldDisplay = this.shouldDisplay.bind(this)
    this.dismissPopup = this.dismissPopup.bind(this)
    this.state = {
      dismissed: !!Cookie.get('cookie_consent')
    }
  }

  shouldDisplay () {
    return this.props.display === 'Yes' && !this.state.dismissed
  }

  dismissPopup () {
    return this.setState({ dismissed: true }, () => Cookie.set('cookie_consent', 'dismissed'))
  }

  render () {
    const {
      button = {},
      classNames,
      dismiss,
      href,
      link,
      message,
      styles,
      target
    } = this.props

    if (this.shouldDisplay()) {
      return (
        <div className={classNames.root}>
          <p className={classNames.message}>
            {message || 'We use cookies to help make this website better, to improve our services and for advertising purposes.'}
            {' '}
            <a
              className={classNames.link}
              href={href || 'https://everydayhero.com/uk/terms/cookies'}
              target={target}>
              {link || 'Learn More'}
            </a>
          </p>
          <Button
            {...button}
            onClick={() => this.dismissPopup()}
            styles={styles.button}>
            {dismiss || 'Got it!'}
          </Button>
        </div>
      )
    }

    return null
  }
}

const mapStateToProps = (store) => selectCookieConsentParams(store)

export default compose(
  connect(mapStateToProps),
  withStyles(styles)
)(CookieConsent)



// WEBPACK FOOTER //
// ./components/utils/CookieConsent/index.js